module.exports = __webpack_public_path__ + "static/img/Default_School_Logo.4d08532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Default_School_Logo.jpg
// module id = I9iX
// module chunks = 125